import React from "react";
import {POINTS_WATCHING} from "./constants";
import FeedbackBar from "../feedbackBar/FeedbackBar";
import withShipment from "../../withShipment";
import {statusSelector} from "../../redux/selectors/global";
import {clearStatus} from "../../redux/actions/global";
import "./PointsWatching.css"
import {employeesSelector, userInfoSelector} from "../../redux/selectors/auth";
import PointsWatchingTable from "./PointsWatchingTable";
import {getEmployees} from "../../redux/actions/auth";
import {ROWS_PER_PAGE} from "../employeeSession/constants";
import {getPointWatching} from "../../redux/actions/settings";
import {pointWatchingSelector} from "../../redux/selectors/customer";



class PointsWatching extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: POINTS_WATCHING.TABLE,
            feedbackBarOpen: false,
            error: false,
            feedbackStatus: '',
            feedbackMessage: '',
            fromDate: this.getFromDate(),
            toDate: this.getToDate(),
            fetchedList: true,
            page: 0,
            rowsPerPage: ROWS_PER_PAGE,
            searchText: '',
            selecting: false,
            selectedEntries: {},
            selectedEmployee: [],
            editEmployee: null,
            pointsWatching: [],
            employees: []
        }
    }

    componentDidMount() {
        this.props.getEmployees({locationId: this.props.user.selectedLocationId})
    }


    componentDidUpdate(prevProps,prevState) {
        if (this.props.status.statusText && prevProps.status.statusText !== this.props.status.statusText) {
            this.openFeedbackBar(this.props.status.statusText, 'error');
        }

        if (prevProps.pointsWatching !== this.props.pointsWatching) {
            this.setState({
                pointsWatching: this.props.pointsWatching,
            })
        }


        if (prevProps.employees !== this.props.employees) {

            const filteredEmployees = this.props.employees.filter(employee => {
                const employeeRoles = employee.authorities.map(auth => auth.authority);

                // Check if employee has ROLE_ADMIN
                if (employeeRoles.includes("ROLE_ADMIN")) {
                    return false;
                }

                // Check if the employee has exactly two roles and both are ROLE_DASHBOARD & ROLE_USER
                if (employeeRoles.length === 2 &&
                  employeeRoles.includes("ROLE_DASHBOARD") &&
                  employeeRoles.includes("ROLE_USER")) {
                    return false;
                }

                return true;
            });

            this.setState({
                employees: filteredEmployees,
            })
        }





    }



    fetchPointWatching = () => {
        const selectedEmployee = this.state.selectedEmployee;

        if (!selectedEmployee || !selectedEmployee.userId) {
            return;
        }

        this.props.getPointWatching({
            userId: selectedEmployee.userId,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
        });
    }


    setFetchedList = (fetched) => {
        this.setState({
            fetchedList: fetched
        })
    }

    setPage = (page) => {
        this.setState({
            page: page
        })
    }
    setRowsPerPage = (rowsPerPage) => {
        this.setState({
            rowsPerPage: rowsPerPage
        })
    }

    handleDateChange = (date, key) => {
        this.setState({
            [key]: date
        })
    }

    handleSearchTextChange = (e) => {
        this.setState({
            searchText: e.target.value
        })
    }

    getFromDate = () => {
        const date = new Date();
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setDate(date.getDate() - 7)
        return date;
    }

    getToDate = () => {
        const date = new Date();
        date.setHours(23);
        date.setMinutes(59);
        date.setSeconds(59);
        return date;
    }

    setCurrentPage = (newPage) => {
        this.setState({
            currentPage: newPage
        })
    }

    displayTable = () => {
        return (
            <PointsWatchingTable
                handleDeleteRow={this.handleDeleteRow}
                data={this.state.employees}
                setCurrentPage={this.setCurrentPage}
                openFeedbackBar={this.openFeedbackBar}
                handleSearchChange={this.handleSearchTextChange}
                searchText={this.state.searchText}
                page={this.state.page}
                setPage={this.setPage}
                rowsPerPage={this.state.rowsPerPage}
                setRowsPerPage={this.setRowsPerPage}
                handleDateChange={this.handleDateChange}
                setFetchedList={this.setFetchedList}
                checkedEntries={this.state.selectedEntries}
                fromDate={this.state.fromDate}
                toDate={this.state.toDate}
                fetchPointWatching={this.fetchPointWatching}
                setSelected={(newEntries, selecting,selectedEmployee) => this.setState({ selectedEntries: newEntries, selecting: selecting, selectedEmployee: selectedEmployee },()=>{
                    this.fetchPointWatching()
                })}
                pointsWatching={this.state.pointsWatching}
            />
        )
    }


    displayCurrentPage = () => {
        switch (this.state.currentPage) {
            case POINTS_WATCHING.TABLE:
                return this.displayTable()
            default:
                return <div>We encountered an error. Please refresh the page.</div>
        }
    }

    openFeedbackBar = (status, message) => {
        this.setState({ feedbackStatus: status, feedbackMessage: message, feedbackBarOpen: true });
    }

    closeFeedbackBar = () => {
        this.setState({ feedbackBarOpen: false, feedbackStatus: '', feedbackMessage: '' }, () => {
            this.props.clearStatus();
        });
    }
    render() {
        return (
            <React.Fragment>
                <FeedbackBar
                    open={this.state.feedbackBarOpen}
                    handleClose={this.closeFeedbackBar}
                    severity={this.state.feedbackStatus}
                    message={this.state.feedbackMessage}
                />

                {this.displayCurrentPage()}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    status: statusSelector(state),
    user: userInfoSelector(state),
    employees: employeesSelector(state),
    pointsWatching: pointWatchingSelector(state),
})


const actionCreators = {
    clearStatus,
    getEmployees,
    getPointWatching,

}

export default withShipment({
    actionCreators,
    mapStateToProps
}, PointsWatching);